@let _newsItemTitle = newsItem()?.title;

<navigation-news
  [forceTitle]="_newsItemTitle ?? ('News.Title' | translate)"
  [isChildRoute]="!!_newsItemTitle"
></navigation-news>
<div>
  <div class="container">
    @if (news(); as _news) {
      <!-- News item view -->
      @if (newsItem(); as _newsItem) {
        <ng-container #newsItem>
          <news-item [item]="_newsItem" [summary]="false" [setBrowserTitle]="true"></news-item>
        </ng-container>
      } @else {
        <!-- News feed view -->
        @for (_newsItem of _news; track $index) {
          <div>
            <news-item [item]="_newsItem" [summary]="true"></news-item>
          </div>
        }
        <!-- End -->
      }
    } @else {
      <loader></loader>
    }
    <footer></footer>
  </div>
</div>
